import React, { Component } from 'react'
import PropTypes from 'prop-types'
// eslint-disable-next-line
import Button from '../../global/button/Button.jsx'
import './CTA.css'
import Image1 from './Strawberry-Colada-Tower-768x690.png'
import Image2 from './Fresh-Mango-Tower-768x631.png'
import { Link } from 'react-router-dom'

/**
 * CTA Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class CTA extends Component {
  /**
   * Default Props
   *
   * @type {{}}
   */
  static defaultProps = {
    buttonText: 'Contact us',
    ctaText: 'Have a Question?',
    image1: Image1,
    image2: Image2,
    link: '/contact'
  }

  /**
   * Prop Types
   *
   * @type {{}}
   */
  static propTypes = {
    buttonOptionText: PropTypes.string,
    ctaText: PropTypes.string,
    image1: PropTypes.string,
    image2: PropTypes.string,
    link: PropTypes.string
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const { ctaText, buttonText, link } = this.props

    return (
      <section className="CTA">
        <header className="CTA__text">
          <h2>{ctaText}</h2>
          <Link to={link} className="btn">
            {buttonText}
          </Link>
        </header>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/page/cta/CTA.jsx